<template>
    <div class="navigation">
        <div style="float: left">
            <img class="logo" src="/assets/logo.png" alt="logo" style="max-height: 60px; margin-top: 20px; margin-right: 15px">
        </div>
        <div class="navigation-menu-body" style="margin-top: 20px">
            <ul>
                <li>
                    <router-link to="/">
                        <span><i class="fa fa-dashboard" style="padding-right: 3px"></i> Etusivu</span>
                    </router-link>
                </li>

                <li style="position: absolute; right: 0px;">
                    <a href="#" class="nav-link dropdown-toggle" title="User menu" data-toggle="dropdown">
                        <span><i class="fa fa-user" style="padding-right: 3px"></i> {{ identityFirstName }}</span>
                        </a>

                    <div class="dropdown-menu dropdown-menu-right dropdown-menu-big">
                        <div class="list-group list-group-flush">
                            <a href="/" class="list-group-item text-primary">Etusivu</a>
                            <a href="/credits/" class="list-group-item text-primary">Luotot</a>
                            <a href="/osinkoja/" class="list-group-item text-primary">Osinkoja</a>
                            <a @click="logout" href="#" class="list-group-item text-danger font-weight-bold">Kirjaudu ulos</a>
                        </div>
                    </div>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
    import session from "@/store/session";
    export default {
        name: "Header",
        computed: {
            identity () {
                return session.state.identity
            },
            identityFirstName () {
                var fullName = this.identity.identityName + ""
                var words = fullName.split(" ")
                return words[1]
            },
            environment () {
                return process.env.VUE_APP_ENVIRONMENT
            },
        },
        methods: {
            logout: function () {
                this.$store.dispatch('logOut');
            }
        }
    }
</script>

<style scoped>

</style>
